export default __webpack_public_path__ + "static/media/Client_Agreement.d2f6e807.pdf";